(function () {
  'use strict';

  const SAVED_WATCH_KEY = 'daluca_selected_watch_v1';
  const CUSTOM_URL = '/collections/custom-watch-straps';
  const MAX_BROAD_RESULTS = 40;
  const DESCRIPTION_IMAGE_ALTS = {
    'daluca-ooak-heavy-duty-1200.png': 'Heavy-duty DaLuca leather watch strap construction',
    'daluca-ooak-design-1200.png': 'DaLuca two-piece watch strap design and traditional fit',
    'daluca-ooak-comfort-1200.png': 'Supple and flexible DaLuca watch strap for all-day wear',
    'daluca-ooak-buckle-1200.png': 'DaLuca stainless steel watch strap buckle options',
    'daluca-ooak-thread-1200.png': 'DaLuca four-ply waxed linen watch strap thread',
    'daluca-ooak-fit-1200.png': 'DaLuca watch strap widths and wrist fit range',
    '1oak-step3b.jpg': 'How to choose the correct custom watch strap width',
    '1oak-step4.jpg': 'How to choose a custom watch strap length',
    '1oak-step5.jpg': 'DaLuca custom watch strap buckle types',
    '1oak-step6.jpg': 'DaLuca custom watch strap stitching types',
    '1oak-step7.jpg': 'DaLuca custom watch strap stitching colors',
    '1oak-step8.jpg': 'DaLuca custom watch strap keeper options',
    '1oak-step9.jpg': 'Venetian Cream leather conditioner for custom watch straps'
  };

  function trackEvent(name, details) {
    const payload = Object.assign({ event: name }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: payload }));
  }

  function compact(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '');
  }

  function words(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function displayModel(record) {
    return String(record.display_model || record.model || '').trim();
  }

  function displayReference(record) {
    return String(
      record._display_reference ||
      record.display_reference ||
      record.canonical_reference ||
      record.reference ||
      ''
    ).trim();
  }

  function recordSearchText(record) {
    if (record._dalucaPdpSearch) return record._dalucaPdpSearch;
    const values = [
      record.brand,
      record.model,
      record.display_model,
      record.reference,
      record.display_reference,
      record.canonical_reference,
      record.family,
      record.series,
      Array.isArray(record.aliases) ? record.aliases.join(' ') : record.aliases,
      Array.isArray(record.search_terms) ? record.search_terms.join(' ') : record.search_terms
    ];
    record._dalucaPdpSearch = values.filter(Boolean).join(' ').toLowerCase();
    record._dalucaPdpCompact = compact(record._dalucaPdpSearch);
    return record._dalucaPdpSearch;
  }

  function scoreRecord(record, query) {
    const queryWords = words(query);
    const queryCompact = compact(query);
    const searchText = recordSearchText(record);
    const searchCompact = record._dalucaPdpCompact;
    const ref = compact(displayReference(record));
    const model = compact(displayModel(record));
    const brand = compact(record.brand);

    if (!queryCompact || queryWords.length === 0) return -1;
    if (!queryWords.every((word) => searchText.includes(word) || searchCompact.includes(compact(word)))) return -1;

    let score = 0;
    if (ref && queryCompact === ref) score += 1000;
    else if (ref && ref.startsWith(queryCompact)) score += 700;
    else if (ref && queryCompact.includes(ref)) score += 520;
    if (model && queryCompact === model) score += 650;
    else if (model && model.startsWith(queryCompact)) score += 430;
    else if (model && model.includes(queryCompact)) score += 300;
    if (brand && queryCompact.startsWith(brand)) score += 90;
    if (searchCompact.startsWith(queryCompact)) score += 130;
    score += Math.max(0, 80 - Math.abs(searchCompact.length - queryCompact.length));
    return score;
  }

  function uniqueResults(records, query) {
    const seen = new Set();
    const matches = records
      .map((record) => ({ record: record, score: scoreRecord(record, query) }))
      .filter((entry) => entry.score >= 0)
      .sort((a, b) => b.score - a.score)
      .filter((entry) => {
        const record = entry.record;
        const key = [record.brand, displayModel(record), displayReference(record), record.lug_width_mm]
          .map(compact)
          .join('|');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((entry) => entry.record);

    return compact(query).length < 3 ? matches.slice(0, MAX_BROAD_RESULTS) : matches;
  }

  function loadDatabase(url) {
    if (window.DaLucaPdpWatchDatabase) {
      return Promise.resolve(window.DaLucaPdpWatchDatabase);
    }
    if (window.DaLucaPdpWatchDatabasePromise) {
      return window.DaLucaPdpWatchDatabasePromise;
    }

    window.DaLucaPdpWatchDatabasePromise = window.DaLucaWatchData.load()
      .then((json) => {
        const source = Array.isArray(json.records) ? json.records : [];
        window.DaLucaPdpWatchDatabase = source.filter((record) => {
          const status = String(record.verification_status || '').toUpperCase();
          return record.brand && record.model && Number(record.lug_width_mm) && status.startsWith('VERIFIED');
        });
        return window.DaLucaPdpWatchDatabase;
      })
      .catch((error) => {
        window.DaLucaPdpWatchDatabasePromise = null;
        throw error;
      });

    return window.DaLucaPdpWatchDatabasePromise;
  }

  function readSavedWatch() {
    try {
      const saved = JSON.parse(localStorage.getItem(SAVED_WATCH_KEY) || 'null');
      return saved && Number(saved.lug_width_mm) ? window.DaLucaWatchData.safeSaved(saved) : null;
    } catch (error) {
      return null;
    }
  }

  function saveWatch(record) {
    try {
      localStorage.setItem(SAVED_WATCH_KEY, JSON.stringify(record));
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; fit checking still works.
    }
  }

  function selectMatchingWidth(width) {
    const target = String(width).replace(/\s*mm$/i, '');
    const selectors = Array.from(document.querySelectorAll('variant-selects'));

    selectors.forEach((selector) => {
      const fields = Array.from(selector.querySelectorAll('input[type="radio"], select'));
      fields.forEach((field) => {
        if (field.tagName === 'SELECT') {
          const option = Array.from(field.options).find((item) => {
            return String(item.value).replace(/\s*mm$/i, '') === target;
          });
          if (option && !option.disabled) {
            field.value = option.value;
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }

        const value = String(field.value || field.dataset.value || '').replace(/\s*mm$/i, '');
        if (value === target && !field.disabled && !field.classList.contains('is-disabled')) {
          field.click();
        }
      });
    });
  }

  function initFitChecker(root) {
    if (root.dataset.dalucaReady === 'true') return;
    root.dataset.dalucaReady = 'true';

    const databaseUrl = root.dataset.databaseUrl;
    const productWidths = new Set(
      String(root.dataset.productWidths || '')
        .split(',')
        .map((value) => String(value).trim())
        .filter(Boolean)
    );
    const customAnyWidth = root.dataset.customAnyWidth === 'true';
    const input = root.querySelector('[data-daluca-pdp-fit-input]');
    const clear = root.querySelector('[data-daluca-pdp-fit-clear]');
    const results = root.querySelector('[data-daluca-pdp-fit-results]');
    const answer = root.querySelector('[data-daluca-pdp-fit-answer]');
    const saved = root.querySelector('[data-daluca-pdp-fit-saved]');
    let database = [];
    let databaseLoading = false;
    let activeIndex = -1;
    let latestResults = [];
    let selectedWatch = null;
    let selectingWidth = false;

    function closeResults() {
      results.hidden = true;
      window.DaLucaI18n.setHtml(results, '');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function ensureLocalDatabase() {
      if (database.length) return Promise.resolve(database);
      if (databaseLoading) return window.DaLucaPdpWatchDatabasePromise;
      databaseLoading = true;
      if (input.value.trim().length >= 2) {
        results.hidden = false;
        window.DaLucaI18n.setHtml(results, '<div class="daluca-pdp-fit__loading">Loading verified watch fit data…</div>');
        input.setAttribute('aria-expanded', 'true');
      }
      return loadDatabase(databaseUrl)
        .then((records) => {
          database = records;
          databaseLoading = false;
          closeResults();
          if (input.value.trim().length >= 2) renderResults(input.value);
          return records;
        })
        .catch((error) => {
          databaseLoading = false;
          closeResults();
          input.placeholder = 'Fit search unavailable — open the full Strap Finder';
          throw error;
        });
    }

    function showSavedWatch() {
      const watch = readSavedWatch();
      if (!watch) {
        saved.hidden = true;
        return;
      }
      const label = [watch.brand, displayModel(watch), displayReference(watch)]
        .filter(Boolean)
        .join(' ');
      window.DaLucaI18n.setHtml(saved, '<button type="button">Use saved watch: ' + escapeHtml(label) + ' · ' + escapeHtml(watch.lug_width_mm) + 'mm</button>');
      saved.hidden = false;
      saved.querySelector('button').addEventListener('click', () => chooseWatch(watch));
    }

    function renderAnswer(record, selectWidth = true) {
      const width = String(Number(record.lug_width_mm));
      const watchName = [record.brand, displayModel(record), displayReference(record)]
        .filter(Boolean)
        .join(' ');
      const productRoot = root.closest('.daluca-pdp') || document;
      const widthInput = Array.from(productRoot.querySelectorAll('variant-selects input:checked, variant-selects select')).find(field => /width|size/i.test(field.name || window.DaLucaI18n.chainText(() => (field), [{kind:"member", optional:false, computed:false, key: () => ("closest")}, {kind:"call", optional:false, args: () => ['fieldset']}, {kind:"member", optional:true, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['legend']}, {kind:"text", optional:true}]) || ''));
      const activeWidth = widthInput ? String(parseFloat(widthInput.value)) : '';
      const fits = customAnyWidth || (productWidths.has(width) && (selectWidth || !activeWidth || activeWidth === width));
      root.dataset.dalucaFitMismatch = fits ? 'false' : 'true';

      answer.className = 'daluca-pdp-fit__answer';
      answer.hidden = false;

      if (fits) {
        answer.classList.add(customAnyWidth ? 'is-custom' : 'is-fit');
        window.DaLucaI18n.setHtml(answer, customAnyWidth
          ? '<strong>Yes — we can make this in the exact ' + escapeHtml(width) + 'mm width.</strong>' +
            escapeHtml(watchName) + ' requires ' + escapeHtml(width) + 'mm. Choose ' + escapeHtml(width) + 'mm in the custom options; we never round widths.'
          : '<strong>Yes — this strap fits your watch in ' + escapeHtml(width) + 'mm.</strong>' +
            escapeHtml(watchName) + ' requires an exact ' + escapeHtml(width) + 'mm strap. We selected that width when it was available.');
        if (!customAnyWidth && selectWidth) { selectingWidth = true; selectMatchingWidth(width); selectingWidth = false; }
      } else {
        answer.classList.add('is-mismatch');
        window.DaLucaI18n.setHtml(answer, '<strong>' + (productWidths.has(width) ? 'The selected strap width does not match the required ' : 'This ready-made strap is not offered in the required ') + escapeHtml(width) + 'mm width.</strong>' +
          escapeHtml(watchName) + ' requires ' + escapeHtml(width) + 'mm, and we never recommend rounding. ' +
          '<a href="' + CUSTOM_URL + '?daluca_custom_width=' + encodeURIComponent(width) + '">See custom ' + escapeHtml(width) + 'mm straps →</a>');
      }

      trackEvent('daluca_pdp_fit_checked', {
        watch_brand: String(record.brand || ''),
        watch_model: displayModel(record),
        required_width_mm: Number(record.lug_width_mm),
        result: fits ? (customAnyWidth ? 'custom_available' : 'ready_made_fit') : 'custom_required'
      });
    }

    const productRoot = root.closest('.daluca-pdp') || document;
    productRoot.addEventListener('change', event => {
      if (selectedWatch && !selectingWidth && event.target.closest('variant-selects')) renderAnswer(selectedWatch, false);
    });
    productRoot.addEventListener('submit', event => {
      if (!selectedWatch || root.dataset.dalucaFitMismatch !== 'true' || !event.target.matches('form[action*="/cart/add"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      answer.hidden = false;
      answer.setAttribute('tabindex', '-1');
      answer.focus();
      answer.scrollIntoView({block:'center',behavior:'smooth'});
    }, true);
    clear.addEventListener('click', () => { selectedWatch = null; delete root.dataset.dalucaFitMismatch; });

    function chooseWatch(record) {
      selectedWatch = record;
      saveWatch(record);
      const label = [record.brand, displayModel(record), displayReference(record)]
        .filter(Boolean)
        .join(' ');
      input.value = label;
      clear.hidden = false;
      closeResults();
      renderAnswer(record);
      showSavedWatch();
    }

    function renderResults(query) {
      if (query.trim().length < 2) {
        closeResults();
        return;
      }

      latestResults = uniqueResults(database, query);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;

      if (latestResults.length === 0) {
        window.DaLucaI18n.setHtml(results, '<div class="daluca-pdp-fit__empty">No exact result yet. Try the brand, model family or reference number.</div>');
        return;
      }

      const resultSummary = '<div class="daluca-pdp-fit__result-summary">' +
        escapeHtml(latestResults.length) + ' verified ' + (latestResults.length === 1 ? 'match' : 'matches') +
        '<span>Type more of the reference to narrow the list.</span></div>';

      window.DaLucaI18n.setHtml(results, resultSummary + latestResults.map((record, index) => {
        const reference = displayReference(record);
        const meta = [record.brand, reference ? 'Ref. ' + reference : ''].filter(Boolean).join(' · ');
        return '<button type="button" class="daluca-pdp-fit__result" role="option" data-index="' + index + '">' +
          '<span><strong>' + escapeHtml(displayModel(record)) + '</strong><small>' + escapeHtml(meta) + '</small></span>' +
          '<em>' + escapeHtml(record.lug_width_mm) + 'mm</em></button>';
      }).join(''));

      results.querySelectorAll('[data-index]').forEach((button) => {
        button.addEventListener('click', () => chooseWatch(latestResults[Number(button.dataset.index)]));
      });
    }

    function setActiveResult(nextIndex) {
      const buttons = Array.from(results.querySelectorAll('[data-index]'));
      if (!buttons.length) return;
      activeIndex = (nextIndex + buttons.length) % buttons.length;
      buttons.forEach((button, index) => {
        button.classList.toggle('is-active', index === activeIndex);
        button.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
      });
      buttons[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) {
        if (database.length) renderResults(input.value);
        else ensureLocalDatabase().catch(() => {});
      }
    });

    input.addEventListener('input', () => {
      clear.hidden = input.value.length === 0;
      answer.hidden = true;
      if (input.value.trim().length < 2) {
        closeResults();
      } else if (database.length) {
        renderResults(input.value);
      } else {
        ensureLocalDatabase().catch(() => {});
      }
    });

    input.addEventListener('keydown', (event) => {
      if (results.hidden) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveResult(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveResult(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        chooseWatch(latestResults[activeIndex]);
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    clear.addEventListener('click', () => {
      input.value = '';
      answer.hidden = true;
      clear.hidden = true;
      closeResults();
      input.focus();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeResults();
    });

    showSavedWatch();

    if (!databaseUrl) {
      input.disabled = true;
      input.placeholder = 'Watch database URL needs to be added in theme settings';
      return;
    }

    // The database loads only when the customer uses search, keeping initial PDP load light.
  }

  function initSecondColorLinks() {
    document.querySelectorAll('[data-daluca-choose-second-color]').forEach((button) => {
      if (button.dataset.dalucaReady === 'true') return;
      button.dataset.dalucaReady = 'true';
      button.addEventListener('click', () => {
        const colorField = Array.from(document.querySelectorAll('.product-form__input')).find((field) => {
          const label = field.querySelector('.form__label');
          return label && /color/i.test(window.DaLucaI18n.sourceText(label));
        });
        if (colorField) {
          colorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          colorField.setAttribute('tabindex', '-1');
          colorField.focus({ preventScroll: true });
        }
      });
    });
  }

  function initGalleryCounters() {
    document.querySelectorAll('[data-daluca-gallery-counter]').forEach((counter) => {
      if (counter.dataset.dalucaReady === 'true') return;
      const gallery = counter.closest('.product-image-container');
      const slider = gallery ? gallery.querySelector('product-slider') : null;
      const current = counter.querySelector('[data-daluca-gallery-current]');
      const total = counter.querySelector('[data-daluca-gallery-total]');
      if (!slider || !current || !total) return;

      const update = () => {
        const slides = Array.from(slider.querySelectorAll('.product-images__slide.is-active'));
        const selected = slides.findIndex((slide) => slide.classList.contains('is-selected'));
        window.DaLucaI18n.setText(total, String(slides.length || 1));
        window.DaLucaI18n.setText(current, String(selected >= 0 ? selected + 1 : 1));
      };

      counter.dataset.dalucaReady = 'true';
      update();
      const observer = new MutationObserver(update);
      observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });
  }

  function initGalleryNavigation() {
    document.querySelectorAll('.daluca-pdp product-slider.product-images').forEach((slider) => {
      if (slider.dataset.dalucaNavigationReady === 'true') return;

      const previousButton = slider.querySelector('.flickity-prev');
      const nextButton = slider.querySelector('.flickity-next');

      const update = () => {
        const activeSlides = slider.querySelectorAll('.product-images__slide.is-active');
        slider.classList.toggle('daluca-gallery--multiple', activeSlides.length > 1);
        slider.classList.toggle('daluca-gallery--single', activeSlides.length <= 1);
        const gallery = slider.closest('.product-gallery-container');
        if (gallery) gallery.dataset.dalucaMediaCount = String(activeSlides.length);
      };

      slider.dataset.dalucaNavigationReady = 'true';
      if (previousButton) {
        previousButton.setAttribute('role', 'button');
        previousButton.setAttribute('aria-label', 'Previous product image');
      }
      if (nextButton) {
        nextButton.setAttribute('role', 'button');
        nextButton.setAttribute('aria-label', 'Next product image');
      }
      update();

      new MutationObserver(update).observe(slider, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    });
  }

  function initGalleryHoverZoom() {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    document.querySelectorAll('.daluca-pdp .product-single__media-image').forEach((frame) => {
      if (frame.dataset.dalucaZoomReady === 'true') return;
      const image = frame.querySelector('img');
      const zoomLink = frame.querySelector('.product-single__media-zoom');
      if (!image || !zoomLink) return;

      let pointerStart = null;
      frame.dataset.dalucaZoomReady = 'true';
      frame.classList.add('daluca-gallery__zoom-frame');
      image.draggable = false;

      frame.addEventListener('pointerdown', (event) => {
        pointerStart = { x: event.clientX, y: event.clientY };
      });

      if (canHover) {
        frame.addEventListener('pointerenter', () => {
          image.classList.add('is-daluca-hover-zoomed');
        });
        frame.addEventListener('pointermove', (event) => {
          const bounds = frame.getBoundingClientRect();
          const x = Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100));
          const y = Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100));
          image.style.transformOrigin = x + '% ' + y + '%';
        });
        frame.addEventListener('pointerleave', () => {
          image.classList.remove('is-daluca-hover-zoomed');
          image.style.transformOrigin = '50% 50%';
          pointerStart = null;
        });
      }

      image.addEventListener('click', (event) => {
        if (pointerStart) {
          const moved = Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y);
          if (moved > 8) return;
        }
        trackEvent('daluca_pdp_gallery_opened');
        zoomLink.click();
      });
    });
  }

  function initPriceInAddButton() {
    document.querySelectorAll('.daluca-pdp').forEach((root) => {
      if (root.dataset.dalucaPriceButtonReady === 'true') return;
      const priceRoot = root.querySelector('.product-price-container');
      const button = root.querySelector('.product-form .single-add-to-cart-button[name="add"]');
      const label = button ? button.querySelector(':scope > span:first-child') : null;
      if (!priceRoot || !button || !label) return;

      const baseLabel = button.dataset.dalucaBaseLabel || window.DaLucaI18n.sourceText(label).trim() || 'Add to cart';
      button.dataset.dalucaBaseLabel = baseLabel;
      const update = () => {
        if (button.disabled || button.classList.contains('sold-out')) return;
        const amount = priceRoot.querySelector('ins .amount');
        if (!amount) return;
        const upgradeToggle = root.querySelector('[data-daluca-quick-release-toggle]');
        const upgradedTotal = root.querySelector('[data-daluca-total-upgraded]');
        const displayAmount = upgradeToggle && upgradeToggle.checked && upgradedTotal
          ? window.DaLucaI18n.sourceText(upgradedTotal).trim()
          : window.DaLucaI18n.sourceText(amount).trim();
        window.DaLucaI18n.setText(label, baseLabel + ' — ' + displayAmount);
      };

      root.dataset.dalucaPriceButtonReady = 'true';
      update();
      new MutationObserver(update).observe(priceRoot, { childList: true, subtree: true, characterData: true });
      root.addEventListener('daluca:upgrade-change', update);
    });
  }

  function initProductDescriptionSources() {
    if (window.DaLucaI18n.locale === 'en') return;
    document.querySelectorAll('.daluca-product-details [data-daluca-description]').forEach((root) => {
      if (root.dataset.dalucaSourceMapped === 'true') return;
      const section = root.closest('.daluca-product-details');
      const payload = section && section.previousElementSibling;
      if (!payload || !payload.matches('template[data-daluca-description-source]')) return;
      try {
        if (window.DaLucaI18n.registerProductSource(root, payload.content.textContent)) root.dataset.dalucaSourceMapped = 'true';
      } catch (error) { /* The existing unpaired description remains the fallback. */ }
    });
  }

  function initProductStory() {
    document.querySelectorAll('[data-daluca-story-target]').forEach((target) => {
      const source = document.querySelector('.daluca-product-details__description[data-daluca-description]');
      const serverRendered = target.dataset.dalucaServerRendered === 'true';

      if (serverRendered) {
        if (target.dataset.dalucaSourceCleaned === 'true') return;
        if (!source) {
          target.dataset.dalucaSourceCleaned = 'true';
          target.dataset.dalucaReady = 'true';
          return;
        }

        const intro = source.querySelector('.product-features, .custom-features') || source;
        const primaryList = intro.querySelector(':scope > ul') || source.querySelector('.product-features ul, .custom-features ul');
        const sourceMode = String(target.dataset.dalucaStorySource || '');
        const paragraph = sourceMode === 'paragraph'
          ? (intro.querySelector(':scope > p') || source.querySelector('.prod-overview'))
          : null;

        const heading = intro.querySelector(':scope > h2');
        const subheading = intro.querySelector(':scope > h5');
        [heading, subheading, paragraph].forEach((node) => {
          if (node) node.remove();
        });

        if (primaryList) {
          const specNames = /^(length|width|widths|thickness|buckle|hardware|material|features)$/i;
          Array.from(primaryList.children).forEach((item) => {
            const normalizedText = String(window.DaLucaI18n.productSourceText(item) || '').replace(/\s+/g, ' ').trim();
            const colonIndex = normalizedText.indexOf(':');
            if (colonIndex < 1) return;
            const name = normalizedText.slice(0, colonIndex).trim();
            const value = normalizedText.slice(colonIndex + 1).trim();

            if (/^description$/i.test(name) && value && sourceMode === 'description') {
              item.remove();
              return;
            }

            if (specNames.test(name) && value) item.remove();
          });

          if (!primaryList.children.length) primaryList.remove();
        }

        target.hidden = false;
        target.dataset.dalucaSourceCleaned = 'true';
        target.dataset.dalucaReady = 'true';
        return;
      }

      if (target.dataset.dalucaReady === 'true') return;
      if (!source) return;

      const intro = source.querySelector('.product-features, .custom-features') || source;
      const copy = target.querySelector('[data-daluca-story-copy]');
      const specs = target.querySelector('[data-daluca-story-specs]');
      const primaryList = intro.querySelector(':scope > ul') || source.querySelector('.product-features ul, .custom-features ul');
      let contentMoved = false;

      const heading = intro.querySelector(':scope > h2');
      const subheading = intro.querySelector(':scope > h5');
      const paragraph = intro.querySelector(':scope > p') || source.querySelector('.prod-overview');

      [heading, subheading, paragraph].forEach((node) => {
        if (!node || !copy) return;
        copy.appendChild(node);
        contentMoved = true;
      });

      if (primaryList && specs) {
        const specNames = /^(length|width|widths|thickness|buckle|hardware|material|features)$/i;
        Array.from(primaryList.children).forEach((item) => {
          const normalizedText = String(window.DaLucaI18n.productSourceText(item) || '').replace(/\s+/g, ' ').trim();
          const colonIndex = normalizedText.indexOf(':');
          if (colonIndex < 1) return;
          const name = normalizedText.slice(0, colonIndex).trim();
          const value = normalizedText.slice(colonIndex + 1).trim();
          const nativeField = window.DaLucaI18n.locale !== 'en' ? window.DaLucaI18n.productField(item) : null;

          if (/^description$/i.test(name) && value && !paragraph) {
            const storyParagraph = document.createElement('p');
            const htmlColonIndex = item.innerHTML.indexOf(':');
            window.DaLucaI18n.setHtml(storyParagraph, nativeField ? nativeField.valueHtml : htmlColonIndex > -1 ? item.innerHTML.slice(htmlColonIndex + 1).trim() : escapeHtml(value));
            copy.appendChild(storyParagraph);
            item.remove();
            contentMoved = true;
            return;
          }

          if (!specNames.test(name) || !value) return;
          const term = document.createElement('dt');
          const detail = document.createElement('dd');
          window.DaLucaI18n.setText(term, nativeField ? nativeField.name : name === 'Widths' ? 'Width' : name);
          if (nativeField) term.setAttribute('data-daluca-spec-source-key', name === 'Widths' ? 'Width' : name);
          const productRoot = target.closest('.daluca-pdp');
          const preciseMaterial = productRoot ? String(productRoot.dataset.dalucaProductMaterial || '').trim() : '';
          window.DaLucaI18n.setText(detail, nativeField ? nativeField.value : /^material$/i.test(name) && preciseMaterial ? preciseMaterial : value);
          if (nativeField) detail.setAttribute('data-daluca-spec-source-text', value);
          specs.appendChild(term);
          specs.appendChild(detail);
          item.remove();
          contentMoved = true;
        });

        if (!primaryList.children.length) primaryList.remove();
        specs.hidden = specs.children.length === 0;
      }

      if (contentMoved) target.hidden = false;
      target.dataset.dalucaReady = 'true';
    });
  }

  function collectLineItemProperties(form) {
    const properties = {};
    new FormData(form).forEach((value, key) => {
      const match = String(key).match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) properties[match[1]] = value;
    });
    return properties;
  }

  function initQuickReleaseUpgrade() {
    document.querySelectorAll('[data-daluca-quick-release]').forEach((upgrade) => {
      if (upgrade.dataset.dalucaReady === 'true') return;
      const root = upgrade.closest('.daluca-pdp');
      const toggle = upgrade.querySelector('[data-daluca-quick-release-toggle]');
      const productFormElement = root ? root.querySelector('product-form:not([data-sticky])') : null;
      const form = productFormElement ? productFormElement.querySelector('form[data-type="add-to-cart-form"]') : null;
      const baseTotal = root ? root.querySelector('[data-daluca-total-base]') : null;
      const upgradedTotal = root ? root.querySelector('[data-daluca-total-upgraded]') : null;
      if (!root || !toggle || !form || !productFormElement) return;

      upgrade.dataset.dalucaReady = 'true';

      const updateTotal = () => {
        if (baseTotal) baseTotal.hidden = toggle.checked;
        if (upgradedTotal) upgradedTotal.hidden = !toggle.checked;
        root.dispatchEvent(new CustomEvent('daluca:upgrade-change'));
        trackEvent('daluca_pdp_quick_release_toggled', { selected: toggle.checked });
      };

      toggle.addEventListener('change', updateTotal);

      form.addEventListener('submit', (event) => {
        if (!toggle.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!form.reportValidity()) return;

        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
        const errorWrapper = productFormElement.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;
        submitButtons.forEach((button) => {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
        });
        if (errorWrapper) errorWrapper.hidden = true;

        const formData = new FormData(form);
        const baseVariantId = Number(formData.get('id'));
        const upgradeVariantId = Number(upgrade.dataset.upgradeVariantId);
        const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
        const items = [{ id: baseVariantId, quantity: quantity }];
        const properties = collectLineItemProperties(form);
        if (Object.keys(properties).length) items[0].properties = properties;
        if (formData.get('selling_plan')) items[0].selling_plan = Number(formData.get('selling_plan'));
        items.push({
          id: upgradeVariantId,
          quantity: 1,
          properties: { 'For strap': window.DaLucaI18n.chainText(() => (document), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.daluca-concierge-header h1']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || 'DaLuca strap' }
        });

        const sections = typeof productFormElement.getSectionsToRender === 'function'
          ? productFormElement.getSectionsToRender().map((section) => section.section)
          : ['cart-drawer', 'cart-bubble'];

        fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        })
          .then((response) => response.json().then((data) => {
            if (!response.ok || data.status) return Promise.reject(data);
            return data;
          }))
          .then((response) => {
            if (typeof productFormElement.renderContents === 'function' && response.sections) {
              productFormElement.renderContents(response);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: { product: response.items && response.items[0] ? response.items[0] : response }
            }));
            trackEvent('daluca_pdp_quick_release_added', {
              base_variant_id: baseVariantId,
              upgrade_variant_id: upgradeVariantId
            });
          })
          .catch((error) => {
            if (errorWrapper) errorWrapper.hidden = false;
            if (errorMessage) window.DaLucaI18n.setText(errorMessage, (error && (error.description || error.message)) || 'The strap and quick-release upgrade could not be added. Please try again.');
          })
          .finally(() => {
            submitButtons.forEach((button) => {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
            });
          });
      }, true);
    });
  }

  function initMerchandisingTracking() {
    document.querySelectorAll('[data-daluca-upsell-name]').forEach((button) => {
      if (button.dataset.dalucaTrackingReady === 'true') return;
      button.dataset.dalucaTrackingReady = 'true';
      button.addEventListener('click', () => {
        trackEvent('daluca_pdp_addition_selected', {
          addition_name: String(button.dataset.dalucaUpsellName || '')
        });
      });
    });

    document.querySelectorAll('[data-daluca-rotation-link]').forEach((link) => {
      if (link.dataset.dalucaTrackingReady === 'true') return;
      link.dataset.dalucaTrackingReady = 'true';
      link.addEventListener('click', () => trackEvent('daluca_pdp_second_strap_clicked'));
    });

    if (document.documentElement.dataset.dalucaRecommendationTrackingReady !== 'true') {
      document.documentElement.dataset.dalucaRecommendationTrackingReady = 'true';
      document.addEventListener('click', (event) => {
        const link = event.target.closest('product-recommendations .products a');
        if (!link) return;
        trackEvent('daluca_pdp_recommendation_clicked', {
          recommendation_url: link.getAttribute('href') || ''
        });
      });
    }
  }

  function initProductDescriptions() {
    document.querySelectorAll('[data-daluca-description]').forEach((root) => {
      if (root.dataset.dalucaReady === 'true') return;
      root.dataset.dalucaReady = 'true';

      const callouts = Array.from(root.querySelectorAll('.product-callouts'));
      callouts.forEach((group, index) => {
        group.classList.add('daluca-description-callouts-group');
        group.classList.add(index === 0 ? 'daluca-description-callouts-group--top' : 'daluca-description-callouts-group--bottom');
        group.setAttribute('aria-label', index === 0 ? 'Product benefits' : 'Product construction details');
      });

      const detailsSection = root.closest('.daluca-product-details');
      const journeyProcess = detailsSection ? detailsSection.querySelector('[data-daluca-journey-process]') : null;
      if (journeyProcess && callouts.length) {
        callouts.forEach((group) => group.remove());
        detailsSection.classList.add('daluca-product-details--journey-ready');
      }

      root.querySelectorAll('a').forEach((link) => {
        const href = String(link.getAttribute('href') || '');
        if (/venetian-cream/i.test(href) || /venetian cream/i.test(window.DaLucaI18n.productSourceText(link))) {
          link.setAttribute('href', '/collections/leather-care/products/venetian-cream-4oz');
        }
      });

      root.querySelectorAll('li, p').forEach((node) => {
        const text = String(window.DaLucaI18n.productSourceText(node) || '').replace(/\s+/g, ' ').trim();
        if (/^we highly recommend adding a bottle of venetian cream\b/i.test(text)) {
          node.remove();
        }
      });

      root.querySelectorAll('ul').forEach((list) => {
        if (!list.children.length) list.remove();
      });

      root.querySelectorAll('img').forEach((image) => {
        const imageUrl = String(image.currentSrc || image.getAttribute('src') || image.dataset.src || '');
        const filename = imageUrl.split('?')[0].split('/').pop();
        if (!image.getAttribute('alt') && DESCRIPTION_IMAGE_ALTS[filename]) {
          image.setAttribute('alt', DESCRIPTION_IMAGE_ALTS[filename]);
        }
      });

      root.querySelectorAll('.detail-item').forEach((item) => {
        item.classList.toggle('daluca-detail-item--text-only', !item.querySelector('img'));
      });

      root.querySelectorAll('p').forEach((paragraph) => {
        if (paragraph.querySelector('img') && window.DaLucaI18n.productSourceText(paragraph).trim() === '' && !paragraph.closest('.detail-item')) {
          paragraph.classList.add('daluca-description-legacy-image');
        }
      });

      root.querySelectorAll('ul').forEach((list) => {
        if (list.closest('.product-callouts') || list.closest('.details-list')) return;
        list.classList.add('daluca-description-list');
        list.querySelectorAll(':scope > li').forEach((item) => {
          const text = window.DaLucaI18n.productSourceText(item).replace(/\s+/g, ' ').trim();
          const match = text.match(/^([^:]{2,32}):\s*(.+)/);
          const isLong = text.length > 145 || /^(description|recommended use|directions)/i.test(match ? match[1] : '');
          item.classList.add(isLong ? 'daluca-description-copy' : 'daluca-description-spec');

          if (match && !item.querySelector('.daluca-description-label')) {
            const nativeField = window.DaLucaI18n.locale !== 'en' ? window.DaLucaI18n.productField(item) : null;
            if (nativeField) {
              window.DaLucaI18n.setHtml(item, '<strong class="daluca-description-label">' + escapeHtml(nativeField.name) + '</strong><span class="daluca-description-value">' + nativeField.valueHtml + '</span>');
              const label = item.querySelector('.daluca-description-label');
              const detail = item.querySelector('.daluca-description-value');
              label.setAttribute('data-daluca-spec-source-key', nativeField.key);
              detail.setAttribute('data-daluca-spec-source-text', nativeField.sourceValue);
              window.DaLucaI18n.rememberProductSourceText(item, text);
              return;
            }
            const html = item.innerHTML;
            const colonIndex = html.indexOf(':');
            if (colonIndex > -1 && colonIndex < 80) {
              window.DaLucaI18n.setHtml(item, '<strong class="daluca-description-label">' + html.slice(0, colonIndex) + '</strong>' +
                '<span class="daluca-description-value">' + html.slice(colonIndex + 1).trim() + '</span>');
            }
          }
        });
      });
    });
  }

  function readReviewState(widget) {
    const reviewCards = widget.querySelectorAll('.jdgm-rev');
    if (reviewCards.length > 0) return true;

    const reviewCountNodes = Array.from(widget.querySelectorAll('[data-number-of-reviews]'));
    if (widget.matches('[data-number-of-reviews]')) reviewCountNodes.unshift(widget);
    const reviewCounts = reviewCountNodes
      .map((node) => Number(node.getAttribute('data-number-of-reviews')))
      .filter((count) => Number.isFinite(count));
    if (reviewCounts.some((count) => count > 0)) return true;
    if (reviewCounts.some((count) => count === 0)) return false;

    const text = String(window.DaLucaI18n.sourceText(widget) || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (/\b[1-9][0-9,]*\s+(?:verified\s+)?reviews?\b/.test(text)) return true;
    if (/\b(?:0\s+reviews?|no\s+reviews?|be\s+the\s+first)\b/.test(text)) return false;

    return null;
  }

  function initReviewVisibility() {
    document.querySelectorAll('.daluca-review-intro').forEach((intro) => {
      if (intro.dataset.dalucaVisibilityReady === 'true') return;
      intro.dataset.dalucaVisibilityReady = 'true';

      const introSection = intro.closest('.shopify-section') || intro;
      let attempts = 0;
      let observedWidget = null;
      let widgetObserver = null;

      const applyState = (widget, state) => {
        const widgetSection = widget.closest('.shopify-section') || widget;
        introSection.hidden = !state;
        widgetSection.hidden = !state;
      };

      const check = () => {
        const widgets = Array.from(document.querySelectorAll('.jdgm-rev-widg'));
        const widget = widgets.find((candidate) => {
          return intro.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING;
        }) || widgets[0];

        if (widget) {
          if (widget !== observedWidget) {
            if (widgetObserver) widgetObserver.disconnect();
            observedWidget = widget;
            widgetObserver = new MutationObserver(() => {
              const updatedState = readReviewState(widget);
              if (updatedState !== null) applyState(widget, updatedState);
            });
            widgetObserver.observe(widget, {
              attributes: true,
              childList: true,
              subtree: true,
              characterData: true
            });
          }

          const state = readReviewState(widget);
          if (state !== null) {
            applyState(widget, state);
            return;
          }
        }

        attempts += 1;
        if (attempts < 40) {
          window.setTimeout(check, 250);
        } else {
          introSection.hidden = true;
        }
      };

      check();
    });
  }

  function initBundleButtons() {
    document.querySelectorAll('[data-daluca-bundle-add]').forEach((button) => {
      if (button.dataset.dalucaReady === 'true') return;
      button.dataset.dalucaReady = 'true';

      button.addEventListener('click', () => {
        const ids = String(button.dataset.dalucaBundleIds || '')
          .split(',')
          .map((id) => Number(id))
          .filter(Boolean);
        if (!ids.length || button.disabled) return;

        const label = button.querySelector('[data-daluca-bundle-label]');
        const upsellRoot = button.closest('.daluca-pdp-upsells');
        const message = upsellRoot ? upsellRoot.querySelector('[data-daluca-bundle-message]') : null;
        const originalLabel = label ? window.DaLucaI18n.sourceText(label) : '';
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (label) window.DaLucaI18n.setText(label, 'Adding…');
        if (message) message.hidden = true;

        fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: ids.map((id) => ({ id: id, quantity: 1 })) })
        })
          .then((response) => {
            if (!response.ok) return response.json().then((data) => Promise.reject(data));
            return response.json();
          })
          .then((response) => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: { product: response.items && response.items[0] ? response.items[0] : response }
            }));
            if (message) {
              window.DaLucaI18n.setText(message, 'All three care and installation essentials were added to your cart.');
              message.hidden = false;
            }
            trackEvent('daluca_pdp_addition_added', {
              addition_name: String(button.dataset.dalucaUpsellName || 'Leather Care Set'),
              item_count: ids.length
            });
            window.setTimeout(() => {
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open();
            }, 250);
          })
          .catch((error) => {
            if (message) {
              window.DaLucaI18n.setText(message, (error && (error.description || error.message)) || 'One of the additions could not be added. Please use the individual Add buttons.');
              message.hidden = false;
            }
          })
          .finally(() => {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            if (label) window.DaLucaI18n.setText(label, originalLabel);
          });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-daluca-pdp-fit]').forEach(initFitChecker);
    initSecondColorLinks();
    initGalleryCounters();
    initGalleryNavigation();
    initGalleryHoverZoom();
    initProductDescriptionSources();
    initProductStory();
    initQuickReleaseUpgrade();
    initPriceInAddButton();
    initProductDescriptions();
    initReviewVisibility();
    initBundleButtons();
    initMerchandisingTracking();
  }

  function watchDynamicProductContent() {
    if (!document.body || document.documentElement.dataset.dalucaDynamicReady === 'true') return;
    document.documentElement.dataset.dalucaDynamicReady = 'true';
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        init();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      watchDynamicProductContent();
    }, { once: true });
  } else {
    init();
    watchDynamicProductContent();
  }

  document.addEventListener('shopify:section:load', init);
})();


